<template>
  <div id="favorites">
    <div class="title">

      <div class="center">
        <img src="./img/icon_img13.png"/>
      </div>

    </div>
    <div class="tab_area">
      <div class="fav_tab flex ac">
        <div class="fav_item"
             :class="active_fav==index?'active':''"
             @click="choose_fav(index)"
             v-for="(item,index) in fav_list"
             :key="index">{{ item }}
        </div>
      </div>
      <div class="tips_area">未采集到视频夹里的创作记录只保留60天，到期自动删除</div>
      <div class="tab_con">
        <template v-if="active_fav==0">
          <div class="my_cz">
            <div class="query_area flex  ac">
              <div class="all flex ac" @click="getimgList(0)" :style="left_list_Num===0?'background: #838adb42;':''">
                <img src="./img/icon_img23.png"/>
                <p>全部作品</p>
              </div>
              <div class="select">
                <div class="flex ac jc">
                  <p>{{ query_form.status }}</p>
                  <img src="./img/icon_img25.png"/>
                </div>
                <div class="options">
                  <p v-for="(item,index) in status_options"
                     @click="choose_options(item)"
                     :key="index">{{ item.name }}</p>
                </div>
              </div>
            </div>
            <div class="list_area">
              <div class="list_area_left">
                <div v-for="(item,index) in left_list" @click="getimgList(item.num,1)"
                     :style="left_list_Num===index+1?'background: #838adb42;':''">
                  {{ item.name }}（{{ item.number }}）
                </div>
              </div>
              <waterfall ref="waterfall"
                         :col="col_count"
                         :width="300"
                         :gutterWidth="10"
                         :data="water_draw_list"
                         @loadmore="loadmore_draw"
                         :height="'100%'"
                         v-if="water_draw_list.length"
                  >
                <template>
                  <div class="cell_item"
                       v-for="(item, index) in water_draw_list"
                       :key="index">
                    <div class="create_error"
                         v-if="item.status == 3">
                      <img class="error_icon"
                           src="./img/image_error.png"
                           alt="">
                      <div class="error_text">很遗憾，绘制失败 !</div>
                    </div>
                    <video controlslist="nodownload"
                           role="application" controls preload="none" v-loading="true"
                           :poster="item.cover_url"
                           :src="item.local_video_url=''?item.video_url:item.local_video_url">
                    </video>
                    <div class="more">
                      <img src="./img/icon_img20.png"
                           class="icon"/>
                      <div class="more_list">
                        <div class="more_item"
                             @click="handleDelCate(item)">删除
                        </div>
                        <div class="more_item"
                             @click="downloadVideo(item)">下载
                        </div>
                      </div>
                    </div>
<!--                    <div class="cell_item_cj"-->
<!--                         v-if="left_list.num == 1||left_list.num == 2"-->
<!--                         @click="handle_cj(item)">-->
<!--                      <div class="icon">-->
<!--                        +-->
<!--                      </div>-->
<!--                      <span>采集</span>-->
<!--                    </div>-->
                  </div>
                </template>
              </waterfall>
              <div class="list_area" v-else>
              </div>
            </div>

          </div>
        </template>
        <div class="my_hj"
             v-if="active_fav==1">
          <div class="my_hj_item add"
               @click="add_cate">
            <img src="./img/icon_img15.png"/>
            <p>创建画夹</p>
          </div>
          <div class="my_hj_item"
               v-for="(item,index) in cate_list"
               :key="index">
            <div class="pic">
              <img class="img"
                   :src="item.logo_url"/>
              <div class="more">
                <img src="./img/icon_img20.png"
                     class="icon"/>
                <div class="more_list">
                  <div class="more_item"
                       @click="editCatte(item)">编辑画夹
                  </div>
                  <!-- <div class="more_item"  @click="handle_share">分享</div> -->
                  <div class="more_item"
                       @click="handleDelCate(item,index)">删除
                  </div>
                </div>
              </div>
            </div>
            <div class="text">
              <img src="./img/icon_img18.png"
                   alt=" "/>
              <p><span>{{ item.name }}</span></p>
            </div>
          </div>
        </div>
        <template v-if="active_fav==2">
          <div class="my_dy">
            <Empty></Empty>
          </div>
        </template>
      </div>
    </div>

    <!--    <drawCateEdit ref="drawCateEdit"-->
    <!--                  @close="fetchCateList"></drawCateEdit>-->
  </div>
</template>

<script>
import Empty from '@/components/Empty'
import drawCateEdit from '@/components/DrawCateEdit'
import utils from "../../utils";

export default {
  components: {Empty, drawCateEdit},
  data() {
    return {
      // fav_list: ['我的创作', '我的画夹'],
      fav_list: ['我的创作',],
      active_fav: 0,
      is_mange_status: false,
      is_all_select: false,
      status_options: [
        {name: '全部状态', type: 'allStatus'},
        // {name: '已采集', type: 'hasCate'},
        // {name: '未采集', type: 'noCate'},
        // {name: '生成失败', type: 'createFail'},
      ],
      query_form: {
        status: '全部状态',
        keywords: '',
        action: ""
      },
      count: 0,
      col_count: 4,
      water_draw_list: [],
      page: 1,
      left_list_Num: 0,
      left_list: [
        {name: 'Runway', num: 1, number: 0,},
        {name: 'Pika', num: 2, number: 0,},
        {name: 'Viggle', num: 3, number: 0,},
        {name: 'Luma', num: 4, number: 0,},
        {name: '人物转动漫', num: 5, number: 0,},
        {name: '人物换脸', num: 6, number: 0,},
      ],
      darwtype: ''
    }
  },
  created() {
    this.getimgList(0, 1)
    // this.fetchDrawList()
    // this.fetchCateList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  methods: {
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false
      } else {
        return true
      }
    },
    choose_fav(index) {
      this.active_fav = index
    },
    handle_publish() {
      this.$message.success('发布事件')
    },
    handle_share() {
      this.$message.success('分享事件')
    },
    handleDelCate(item) {
      console.log("item=", item)

      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/all/${item.id}/`).then((res) => {
          this.$message.success('删除成功')
          this.getimgList(this.left_list_Num, this.page)
        })
      })
    },
    close() {
    },
    //创建画夹
    add_cate() {
      if (!this.checkLogin()) {
        return
      }
      this.$refs.drawCateEdit.show()
    },
    //编辑画夹
    editCatte(item) {
      this.$refs.drawCateEdit.show(item)
    },
    //切换管理状态
    handle_mange() {
      this.is_mange_status = !this.is_mange_status
      this.is_all_select = false
    },
    //选择状态
    choose_options(item) {
      this.query_form.status = item.name
      this.query_form.action = item.type
    },

    //我的创作加载更多
    loadmore_draw() {
      console.log("绘画广场加载更多")
      this.page++;
      this.getimgList(this.left_list_Num)
    },
    //下载
    down(item) {
      //请求接口获取原图，再下载
    },
    //采集到
    handle_cj(item) {
      this.$refs.drawCateEdit.show(item, 1)
    },
    goTo(item) {
      this.$router.push('/drawDetail?draw_id=' + item.draw_id)
    },
    windowResize() {
      let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (screenWidth < 1042) {
        this.col_count = 2
      } else if (screenWidth < 1352) {
        this.col_count = 3
      } else if (screenWidth < 1980) {
        this.col_count = 4
      } else {
        this.col_count = 5
      }
    },
    getimgList(item, num) {
      if (item === 0) {
        this.left_list_Num = 0
      } else {
        this.left_list_Num = item
      }
      if (num) {
        console.log("num=", num)
        this.page = 1
      }
      // return
      this.$http.get('/front/aivideo/all/', {
        params: {
          soft: item,
          page: num ? num : this.page,
          size: 20,
        }
      }).then((res) => {
        if (res.status == 200) {
          if (item === 0) {
            this.left_list[0].number = res.data.runway_total
            this.left_list[1].number = res.data.pika_total
            this.left_list[3].number = res.data.luma_total
            this.left_list[2].number = res.data.viggle_total
            this.left_list[5].number = res.data.vmagic_face_total
            this.left_list[4].number = res.data.vmagic_video_total
            // res.data.item_list.forEach((item) => {
            //   this.water_draw_list.push(item)
            // })
            if (res.data.item_list.length != 0) {
              res.data.item_list.forEach((item) => {
                this.water_draw_list.push(item)
              })
            }
          } else {
            if (this.page == 1) {
              this.water_draw_list = []
            }
            if (this.page == 1) {
              this.water_draw_list = res.data.item
            } else {
              if (res.data.item.length != 0) {
                res.data.item.forEach((item) => {
                  this.water_draw_list.push(item)
                })
              }
            }
          }
        }
      })
    },
    downloadVideo(is_video, ) {
      console.log(is_video)
      // return


      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        }else{
          let message = res.message;
          utils.createErrTip(message)
        }
      }).finally(() => {
        this.loading = false
      })

    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#favorites {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.title {
  width: 100%;
  height: 116px;
  background: linear-gradient(270deg, #693fff 0%, #b23fff 100%);
  border-radius: 10px 0 0 0;
display: flex;
  justify-content: center;
  align-items: center;
  .center {
    margin-top: 11px;
    margin-bottom: 11px;
  }
}

.tab_area {
  margin: 30px 0;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .fav_tab {
    border-bottom: 1px solid #fff;

    .fav_item {
      cursor: pointer;
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      padding: 8px 0;
      margin-right: 40px;
      position: relative;
      top: 1px;
      border-bottom: 4px solid transparent;

      &.active {
        color: #5865f2;
        border-bottom: 4px solid #5865f2;
      }
    }
  }

  .tips_area {
    font-size: 12px;
    color: #f0b132;
    padding: 10px 0 20px;
  }

  .tab_con {
    flex: 1;
    overflow-y: auto;

    .my_cz {
      height: 100%;
      display: flex;
      flex-direction: column;

      .query_area {
        margin-bottom: 10px;
        position: relative;
        z-index: 9;

        .all {
          width: 244px;
          margin-right: 40px;
          padding: 12px;
          border-radius: 8px;
          //background: #838adb42;
          cursor: pointer;

          img {
            width: 14px;
            height: 14px;
            margin-right: 10px;
          }

          p {
            font-size: 14px;
            color: #fff;
          }
        }

        .all:hover {
          background: #838adb42;
        }

        .mange {
          height: 40px;
          border-radius: 44px;
          background: #2e2f34;
          padding: 0 20px;
          cursor: pointer;

          img {
            width: 14px;
            height: 14px;
            margin-right: 6px;
          }

          p {
            font-size: 14px;
          }

          &:hover {
            background: #101112;
          }
        }

        .all_select {
          p {
            margin-left: 20px;
            font-size: 14px;

            img {
              width: 18px;
              height: 18px;
              margin-right: 5px;
            }

            .count {
              font-weight: bold;
              margin: 0 5px;
            }
          }

          .all_check {
            cursor: pointer;
          }
        }

        .select {
          width: 126px;
          height: 40px;
          line-height: 40px;
          border-radius: 40px;
          border: 1px solid #5b576c;
          //margin-left: 20px;
          color: #fff;
          cursor: pointer;
          box-sizing: border-box;

          img {
            width: 16px;
            height: 16px;
            margin-left: 20px;
          }

          .options {
            display: none;
            padding: 5px;
            background: #1e1f22;

            p {
              width: 90%;
              margin-left: 5%;
              height: 34px;
              line-height: 34px;
              border-radius: 4px;
              color: #fff;
              text-align: center;
            }
          }

          &:hover {
            background: #838adb42;

            .options {
              display: block;

              p {
                &:hover {
                  background: #838adb42;
                }
              }
            }
          }
        }

        .search {
          height: 40px;
          line-height: 40px;
          border-radius: 40px;
          border: 1px solid #5b576c;
          margin-left: 20px;
          color: #fff;
          cursor: pointer;
          box-sizing: border-box;

          img {
            width: 18px;
            height: 18px;
            margin: 0 10px;
            filter: grayscale(95%);
          }

          input {
            flex: 1;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            background: transparent;
            border: 0;
            color: #fff;
          }

          &:hover {
            border: 1px solid #fff;
          }
        }
      }

      .list_area {
        height: calc(100% - 42px);
        min-height: 150px;
        overflow: hidden;
        display: flex;

        .cell_item {
          width: 300px;
          position: relative;
          overflow: hidden;
          border-radius: 10px;
          margin-bottom: 10px;
          cursor: pointer;

          video {
            width: 300px;
            height: 300px;
            background: black;
          }

          .cell_item_cj {
            display: none;
            position: absolute;
            left: 10px;
            top: 10px;
            width: 64px;
            height: 30px;
            text-align: center;
            background: #9d1cff;
            border-radius: 8px;
            padding-top: 5px;
            cursor: pointer;

            .icon {
              display: inline-block;
              width: 12px;
              height: 12px;
              background: #fff;
              border-radius: 2px;
              color: #9d1cff;
              font-weight: bold;
              line-height: 12px;
              font-size: 12px;
              margin-right: 5px;
            }

            span {
              font-size: 12px;
              color: #fff;
            }
          }

          .more {
            display: none;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;
            height: 30px;

            .icon {
              background: rgba(0, 0, 0, 0.7);
              border-radius: 4px;
            }

            .more_list {
              display: none;
              position: absolute;
              right: 0;
              top: 30px;
              border-radius: 10px;
              width: 114px;
              padding: 6px;
              background-color: rgba(30, 31, 34, 1);

              .more_item {
                width: 100%;
                text-align: center;
                line-height: 34px;
                border-radius: 5px;
                color: #fff;
                cursor: pointer;

                &:hover {
                  background-color: #383b52;
                }
              }
            }

            &:hover {
              .more_list {
                display: block;
              }
            }
          }

          &:hover {
            .more,
            .cell_item_cj {
              display: block;
            }
          }
        }

        .list_area_left {

          margin-right: 40px;

          div {
            color: white;
            font-size: 14px;
            width: 244px;
            padding: 12px;
            border-radius: 8px;
            //background: #838adb42;
            margin-bottom: 10px;
            cursor: pointer;
          }

          div:hover {
            background: #838adb42;
          }


        }
      }
    }

    .my_hj {
      display: flex;
      flex-wrap: wrap;
      margin-left: -13px;

      .my_hj_item {
        width: 260px;
        height: 260px;
        margin-left: 13px;
        margin-right: 13px;
        margin-bottom: 26px;
        border-radius: 10px;
        cursor: pointer;

        &.add {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          border: 3px dotted rgba(123, 123, 123, 1);

          img {
            width: 56px;
            height: 56px;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            color: #fff;
          }

          &:hover {
            background: #2e3138;
          }
        }

        .pic {
          position: relative;
          padding-top: 80%;
          border-radius: 10px 10px 0 0;
          overflow: hidden;
          cursor: pointer;

          .publish {
            display: none;
            position: absolute;
            top: 10px;
            left: 10px;
            width: 64px;
            line-height: 32px;
            background-color: rgba(88, 101, 242, 0.6);
            border-radius: 10px;

            p {
              font-size: 12px;
              color: #fff;
              margin-left: 5px;
            }

            &:hover {
              background-color: rgba(88, 101, 242, 1);
            }
          }

          .more {
            display: none;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;
            height: 30px;

            .icon {
              background: rgba(0, 0, 0, 0.7);
              border-radius: 4px;
            }

            .more_list {
              display: none;
              position: absolute;
              right: 0;
              top: 30px;
              border-radius: 10px;
              width: 114px;
              padding: 6px;
              background-color: rgba(30, 31, 34, 1);

              .more_item {
                width: 100%;
                text-align: center;
                line-height: 34px;
                border-radius: 5px;
                color: #fff;
                cursor: pointer;

                &:hover {
                  background-color: #383b52;
                }
              }
            }

            &:hover {
              .more_list {
                display: block;
              }
            }
          }

          .img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          .num_area {
            position: absolute;
            right: 10px;
            bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: end;

            img {
              width: 14px;
              height: 14px;
              margin-left: 10px;
            }

            span {
              font-size: 12px;
              color: #fff;
              margin-left: 5px;
            }
          }
        }

        .text {
          background: #2d2e32;
          padding: 16px;
          display: flex;
          align-items: center;
          border-radius: 0 0 10px 10px;

          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }

          p {
            font-size: 14px;
            color: #fff;
          }
        }

        &:hover {
          .publish {
            display: flex;
          }

          .more {
            display: block;
          }
        }
      }
    }

    .my_dy {
      width: 100%;
      height: 100%;
    }
  }
}
</style>